import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import Lives from './Lives.jsx';

const BottomBar = ({ config, levelNumber, lives, timerRemaining, score, ballsFound }) => {

    const [restart, setRestart] = useState(false);

    const livesArr = [];
    for (let i = 1; i <= config.lives; i++) {
        if (i <= lives) {
            livesArr.push(<Lives key={i} />);
        } else {
            livesArr.push(<Lives key={i} dead />);
        }
    }

    const totalRedBalls = config.starting_red_balls + (config.level_increment_red_balls * (levelNumber - 1));

    return (
        <div className="bottom-bar">

            {restart &&
                <Redirect push to='/' />
            }

            {/* for decreasing timer bar at gameover */}
            <div className="background"><span></span></div>

            <button className="restart" onClick={() => setRestart(true)}>
                {config.restart_button_text}
            </button>

            <span className="level-number">{`Level ${levelNumber}`}</span>

            <div className="lives">{livesArr}</div>

            <div className="timer hide">
                <svg className="progress-ring" >
                    <circle
                        className="progress-ring__circle"
                        r="90"

                        cx="100"
                        cy="100" />
                    </svg>
                <span className="number">{timerRemaining}</span>
            </div>

            <div className="found-tracker hide">
                <span className="found">{ballsFound}</span>
                /
                <span className="total">{totalRedBalls}</span>
            </div>
            <span className="score">
                Score: <span className="inner">{score.toLocaleString()}</span>
            </span>
        </div>
    );
};

export default BottomBar;
